import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { APIErrors } from '../models/MTError';
import { MessageDialogService } from './message-dialog.service';
// import { AuthenticationService } from './authentication.service';
import { Constants } from '../constants/constants';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class HttpCallsService {


  constructor(private http: HttpClient, private messageService: MessageDialogService, private translate: TranslateService) { }

  // Example method to get data
  httpJsonHeaderOption = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    }), withCredentials: false
  };

  private handleError(error: HttpErrorResponse) {
    let errorMsg: string = 'An unknown error occurred';
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMsg = 'Please re-login';
     
    } else if (error.status === 401) {
      const wwwAuthenticateHeader = error.headers.get('Www-Authenticate');
      if (wwwAuthenticateHeader && wwwAuthenticateHeader.includes('error="invalid_token"')) {
          this.messageService.showErrorMessage(
            this.translate.instant('NOTIFICATIONS_MESSAGES.SESSION_EXPIRED_TITLE'),
            this.translate.instant('NOTIFICATIONS_MESSAGES.SESSION_EXPIRED_MESSAGE'),
            () => {
              // this.authentication.logout();
            }
          );
          errorMsg = 'Token expired. Please login again.';
      } else {
        errorMsg = 'Unauthorized';
      
      }
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      errorMsg = 'Server-side error';
      
    }
    // Return an observable with a user-facing error message.
    let errorObj = new APIErrors(errorMsg);
    errorObj.errorCode = error.status;
    return throwError(() => errorObj);
  }

  httpGetService(url: string): Observable<any> {
    return this.http.get<any>(url, this.httpJsonHeaderOption)
      .pipe(
        catchError((err) => this.handleError(err))
      );
  }

  httpPostService(url: string, requestBody: any, options?: any): Observable<any> {
    const httpOptions = { ...this.httpJsonHeaderOption, ...options };
    return this.http.post<any>(url, requestBody, httpOptions)
      .pipe(
        catchError((err) => this.handleError(err))
      );
  }

  httpPutService(url: string, requestBody: any): Observable<any> {
    return this.http.put<any>(url, requestBody, this.httpJsonHeaderOption)
      .pipe(
        catchError((err) => this.handleError(err))
      );
  }

  httpDeleteService(url: string): Observable<any> {
    return this.http.delete<any>(url, this.httpJsonHeaderOption)
      .pipe(
        catchError((err) => this.handleError(err))
      );
  }

  httpBeforeLoginPost(url: string, requestBody: any): Observable<any> {
    return this.http.post<any>(url, requestBody, { withCredentials: false })
      .pipe(
        catchError((err) => this.handleError(err))
      );
  }



}
